export default [
  {
    value: 1,
    text: "Kişi",
  },
  {
    value: 2,
    text: "Qadın",
  },
]